import { render } from "./management.vue?vue&type=template&id=35ad980b&scoped=true&ts=true"
import script from "./management.vue?vue&type=script&lang=ts&config=true"
export * from "./management.vue?vue&type=script&lang=ts&config=true"

import "./management.vue?vue&type=style&index=0&id=35ad980b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ad980b"]])

export default __exports__